"use client";
import React, { useEffect, useState } from "react";
import Reviews from "./Reviews";

export default function VenueReviewsSection({ data, params, cmsEntry }) {
  const [locationData, setLocationData] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchPlace = async () => {
      const resolvedParams =
        params && typeof params.then === "function" ? await params : params;
      const rawSlug = resolvedParams?.slug;
      const slug = Array.isArray(rawSlug)
        ? rawSlug[rawSlug.length - 1]
        : rawSlug ||
          cmsEntry?.entity_data?.google_place_id ||
          cmsEntry?.entity_data?.address?.google_place_id ||
          cmsEntry?.entity_data?.slug ||
          (typeof cmsEntry?.slug === "string" &&
          cmsEntry.slug.startsWith("venue/")
            ? cmsEntry.slug.replace(/^venue\//, "")
            : cmsEntry?.slug);

      if (!slug) return;
      try {
        const res = await fetch(`/api/place?place_id=${slug}`);
        if (res.ok) {
          const json = await res.json();
          if (isMounted && json && !json.error) setLocationData(json);
        }
      } catch (e) {
        console.warn("Reviews place fetch failed", e);
      }
    };
    fetchPlace();
    return () => {
      isMounted = false;
    };
  }, [params, cmsEntry]);

  if (data?.section_status && data.section_status !== "active") return null;
  if (data?.status === false) return null;
  if (data?.enable_reviews === false || data?.show_reviews === false)
    return null;

  if (!locationData) return null;
  return (
    <div
      className="container !px-4 md:px-0 py-6"
      style={{
        color: "#171717",
        fontFamily: "Bricolage Grotesque",
      }}
    >
      <Reviews locationData={locationData} title={data?.title} />
    </div>
  );
}
